module.exports = require("./fr-DZ.d.ts");